// extracted by mini-css-extract-plugin
export default {"wrapper":"wba","container":"xba","title":"yba","carousel":"zba","review":"Aba","name":"Bba","rating":"Cba","heading":"Eba","body":"Fba"};
    if(module.hot) {
      // 1715632479654
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  